import { type Point, point } from '@ipfabric/utils';
import { array } from 'fp-ts';
import type { Graphics } from 'pixi.js';

export const drawDashedLine = (
  edgeLine: Graphics,
  start: Point,
  end: Point,
  thickness: number,
): void => {
  const base = 3;
  const dash = thickness * base;
  const gap = dash / 2;
  const breakPointLength = dash + gap;
  const xLength = end.x - start.x;
  const yLength = end.y - start.y;
  const lineLength = Math.sqrt(xLength ** 2 + yLength ** 2);
  const scale = dash / breakPointLength;
  const dashesCount = Math.floor(lineLength / breakPointLength);
  const breakPointXLength = xLength / dashesCount;
  const dashXLength = breakPointXLength * scale;
  const breakPointYLength = yLength / dashesCount;
  const dashYLength = breakPointYLength * scale;
  const breakpoints = array.makeBy(dashesCount, (index) =>
    point.create(
      start.x + index * breakPointXLength,
      start.y + index * breakPointYLength,
    ),
  );
  for (const breakpoint of breakpoints) {
    edgeLine.moveTo(breakpoint.x, breakpoint.y);
    const dashEnd = point.create(
      breakpoint.x + dashXLength,
      breakpoint.y + dashYLength,
    );
    edgeLine.lineTo(dashEnd.x, dashEnd.y);
  }
};
